/**
 * The row types the engine coalesces, in their own module so `drain.js` and
 * `index.js` can both name them without importing each other.
 */
export const AUTOSAVE_TYPE = Object.freeze({
  NOTE: 'note',
  BLANK: 'blank',
});
